import { ICellRendererParams } from "ag-grid-enterprise";

import { IgTypography } from "@intelligems/ig-theme";
import { GenericFlexStartContainer } from "@src/components/MainApp/SharedProductPicker/list/containers";
import { ProductPickerProductVariant } from "@src/store/slices/productPicker/types";
import { useCurrency } from "@src/utils/useCurrency";

export const ProductListVariantPrice = ({
  data,
}: ICellRendererParams<ProductPickerProductVariant>) => {
  const currency = useCurrency();

  if (!data?.price) {
    return null;
  }

  return (
    <GenericFlexStartContainer>
      <IgTypography>
        {currency.symbol}
        {data?.price.toFixed(2)}
      </IgTypography>
    </GenericFlexStartContainer>
  );
};
